// The Turnstile API script is loaded in the layout. Poll until window.turnstile is ready.
export function waitForTurnstile(timeout = 10000) {
  if (window.turnstile) return Promise.resolve()

  return new Promise((resolve, reject) => {
    const start = Date.now()
    const check = () => {
      if (window.turnstile) {
        resolve()
        return
      }
      if (Date.now() - start > timeout) {
        reject(new Error("Turnstile unavailable"))
        return
      }
      setTimeout(check, 100)
    }
    check()
  })
}
